// extracted by mini-css-extract-plugin
export default {"main":"Settings_main__PNaYe","header":"Settings_header__PQbyw","container":"Settings_container__UnbZZ","authButton":"Settings_authButton__19O0N"};